<template>
    <div v-if="block" class="formula-block" v-html="content"></div>
    <span v-else v-html="content"></span>
</template>

<script lang="tsx" setup>
import { computed } from "vue";

const props = defineProps<{
    formula: string;
    block: boolean;
}>();

const katex = await import("katex");

const content = computed(() =>
    katex.renderToString(props.formula, {
        throwOnError: false,
    } as any),
);
</script>
<style lang="scss">
@import "../../../node_modules/katex/dist/katex.min.css";

.formula-block {
    text-align: center;
}
</style>
